module.exports = __webpack_public_path__ + "img/tmenu2.92a5a054.png";